<template><div class="campaign-gate-page">
  <preloader v-if="!data" :show-preloader="!data" />
  <div v-else :class="['campaign-gate-page-content']">
    <div class="message-for-creator-wrapper" v-if="isLoggedIn && !!userInfo && userInfo.id === data.user_id && showMessageForCreator && !data.active">
      <div class="message-for-creator d-flex">
        <p>This campaign is in a disabled state. You can see this campaign because you are its owner. This campaign is not available to all other users.</p>
        <button type="button" @click="showMessageForCreator = false">Got it</button>
      </div>
    </div>
    <div class="gate-campaign-step">
      <div class="gate-campaign-step-logo">
        <img class="desktop-on-view" alt="logo" src="../../assets/new-home/icons/fanfrick-logo.svg" />
        <img v-if="getWidth < 991 && showLogo" class="mobile-on-view" src="../../assets/new-home/icons/fanfrick-white-logo.svg" alt=""/>
      </div>
      <div class="gate-campaign-step-info">
        <h1>{{data?.title}}</h1>
        <h2>{{data?.description}}</h2>
        <gate-step
          :is-campaign="true"
          :visit-id="visitId"
          :step="steps[0]"
          :index="0"
          :step-quantity="steps.length"
          @gate-done="gateDone"
          @show-reward="showReward"
          :show-reward="reward_availability"/>
      </div>
      <div/>
    </div>
    <div class="gate-campaign-image">
      <div id="mask" class="gate-campaign-image-mask">
        <img :src="data?.cover" alt=""/>
      </div>
    </div>
  </div>
</div></template>
<script>
import Vue from 'vue'
import {mapActions, mapGetters} from "vuex";
import Preloader from "@/components/Preloader/Preloader";
import GateStep from "@/views/Gate/GateStep";
import BButton from "@/components/__new_ui_kit/Button/BButton";
import {defaultComponentProps, defaultModalEvents, defaultModalProps} from "@/components/__new_ui_kit/Modal/defaults";
import CampaignGateRewardModal from "@/components/__new_ui_kit/Modals/CampaignGateRewardModal/CampaignGateRewardModal";
import api_requests from "@/store/api/api_requests";
export default Vue.extend({
  components: {
    BButton,
    GateStep,
    Preloader

  },
  data() {
    return {
      gateName: this.$route.params.name,
      isGateFromTags: this.$route.params.name?.includes('-'),
      data: null,
      currentStep: null,
      visitId: null,
      steps: [],
      stepIndicators: [],
      allStepsSuccess: false,
      reward_availability: false,
      showLogo: true,
      showMessageForCreator: false
    }
  },
  computed: {
    ...mapGetters(['getWidth', 'isLoggedIn', 'userInfo'])
  },
  methods: {
    ...mapActions(["getGateContent", "createVisitor", "changeResultVisit"]),
    gateDone(index) {
      this.reward_availability = true
      let data = this.$route.params.name.includes('-') ? {
        tag_1: this.$route.params.name.split('-')[0],
        tag_2: this.$route.params.name.split('-')[1],
        step_number: 1,
        visitor_token: localStorage.getItem('visitor')
      } : {
        page_url: this.$route.params.name,
        visitor_token: localStorage.getItem('visitor'),
        step_number: 1
      }
      this.changeResultVisit({
        token: localStorage.getItem('visitor'),
        content_id: this.data.id
      }).then(res => console.log(res))

      api_requests.send_step_info(data).then((response) => {
        this.showReward()
      })
    },
    showReward() {
      this.$modal.show(CampaignGateRewardModal,
        {
          ...defaultComponentProps,
          reward: this.data.rewards[0],
          reward_source: this.data.reward_source
        },
        {
          ...defaultModalProps('campaign-gate-reward-modal'),
          name: 'campaign-gate-reward-modal'
        },
        {
          ...defaultModalEvents()
        })
    },
    formSteps(steps) {
      // если есть степы через OR, то объединить их
      return steps.reduce((acc, cur) => {
        if (!cur.status) return acc
        if (acc.length) {
          const type = acc[acc.length - 1].check.type
          const orStepLastType = acc[acc.length - 1]?.orSteps?.slice(-1)?.[0]?.check?.type
          if (type === 'Or' && !orStepLastType) {
            acc[acc.length - 1]['orSteps'] = [acc[acc.length - 1], cur]
            return acc
          }
          else if (type === 'Or' && orStepLastType === 'Or') {
            acc[acc.length - 1].orSteps.push(cur)
            return acc
          }
        }
        acc.push(cur)
        return acc
      }, [])
    },
    async visitGate() {
      if (!localStorage.getItem('visitor')) {
        const fingerprintInfo = await this.$fingerprint.load().then(res => res.get())
        localStorage.setItem('visitor', fingerprintInfo.visitorId)
      }
      const token = localStorage.getItem('visitor')
      const content_id = this.data.id
      // const res = await this.visit({token, content_id})
      let data = this.$route.params.name.includes('-') ?
        {
          tag_1: this.$route.params.name.split('-')[0],
          tag_2:  this.$route.params.name.split('-')[1],
          visitor_token: localStorage.getItem('visitor')
        } :
        {
          page_url: this.$route.params.name,
          visitor_token: localStorage.getItem('visitor')
        }
      this.visitId = await this.createVisitor(data)
    },
    async loadResources() {
      let payload = {}
      // не очень понятно зачем это, но оставил со старого варианта
      if (this.$route.params.project) {
        payload = {id: this.$route.params.project}
      } else {
        payload = {
          [this.isGateFromTags ? 'tags' : 'name']: this.gateName,
          isTags: this.isGateFromTags
        }
      }
      const res = await this.getGateContent(payload)
      document.title = res.data.title
      if (res.status !== 200) await this.$router.push('/not-found')
      return res
    },
    async fetchGateData() {
      const res = await this.loadResources()
      this.data = res.data
      this.steps = this.formSteps(this.data.steps)
      this.stepIndicators = this.steps.map(_ => false)
      this.currentStep = this.steps[0]
    },
    onScroll(e) {
      window.scrollY > 100 ? this.showLogo = false : this.showLogo = true
    },
  },
  async created() {
    await this.fetchGateData()
    await this.visitGate()
    window.addEventListener('scroll', this.onScroll);

  },
  watch: {
    data() {
      if (!!this.data && this.data.user_id === this.userInfo.id) {
        this.showMessageForCreator = true
      }
    }
  }
})
</script>
<style lang="scss" scoped>;
.campaign-gate-page {
  background-color: #FEF9FA;
  height: 100vh;
  position: relative;
  overflow: hidden;
  @media (max-width: 991px) {
    height: auto;
  }
  .preloader-wrap {
    position: absolute;
    padding: 0;
  }
  .message-for-creator-wrapper {
    position: fixed;
    z-index: 10000;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    top: 0;
    @media(max-width: 991px) {
      width: 100%;
      flex-direction: column;
    }
    .message-for-creator {
      max-width: 589px;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      top: 20px;
      background: #000000;
      padding: 15px;
      border-radius: 10px;
      @media(max-width: 991px) {
        width: 90%;
      }
      p {
        font-weight: 600;
        font-size: 14px;
        color: #fff;
        padding: 0 14px 0 0;
      }
      button {
        display: block;
        width: 285px;
        height: 44px;
        border-radius: 8px;
        background: #d91b5b;
        box-shadow: 0px 15px 45px 0px rgba(202, 0, 68, 0.35);
        color: #fff;
        font-size: 16px;
      }
    }
  }

  &-content {
    max-height: 100vh;
    height: 100%;
    display: flex;
    position: relative;
    @media (max-width: 991px) {
      flex-direction: column-reverse;
      max-height: none;
    }
    .gate-campaign-step {
      padding-top: 24px;
      padding-left: 20px;
      padding-right: 20px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      position: relative;
      &-info {
        height: auto;
        max-width: 589px;
        width: 100%;
        @media (max-width: 992px) {
          h1 {
            font-size: 30px!important;
            line-height: 33px!important;
            text-align: center;
          }
          h2 {
            margin-top: 33px;
            font-size: 12px!important;
            line-height: 18px!important;
            text-align: center;
          }
        }
        &::v-deep(.gate-step) {
          height: 100%;
          margin-top: 56px;
        }
        h1 {
          font-family: "Amatic SC",sans-serif;
          font-weight: 700;
          font-size: 64px;
          line-height: 70px;
          color: #000;
        }
        h2 {
          margin-top: 40px;
          font-family: "Levenim MT", sans-serif;
          font-size: 16px;
          line-height: 24px;
          color: #000;
        }
      }
      &-logo {
        max-width: 589px;
        width: 100%;
        img {
          width: 117px;
        }
        .desktop-on-view {
          display: block;
        }
        .mobile-on-view {
          display: none;
        }
        @media (max-width: 991px) {
          position: fixed;
          top: 10px;
          left: 10px;
          z-index: 100;
          .desktop-on-view {
            display: none;
          }
          .mobile-on-view {
            display: block;
          }
        }
      }
      .text-btn-campaign {
        min-height: 64px;
        height: auto;
        width: 100%;
        word-break: break-all;
        white-space: break-spaces;
        //background: linear-gradient(90deg, #3CA8E0 0%, #27A0DB 100%);
        border-radius: 16px;
      }
    }
    .gate-campaign-image {
      max-width: 930px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      position: relative;
      overflow: hidden;
      @media (min-width: 1920px) {
        max-width: 1930px;
      }
      @media (max-width: 991px) {
        height: 520px;
        // width: calc(100% + 100px);
        // margin-left: -50px;
      }
      @media (max-width: 690px) {
        height: 390px;
        width: calc(100% + 100px);
        margin-left: -50px;
      }
      &-mask {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: calc(100% + 260px);
        width: 100%;
        background-color: #FEF9FA;
        overflow: hidden;
        border-top-left-radius: 70%;
        border-bottom-left-radius: 70%;
        @media (max-width: 991px) {
          border-top-left-radius: 0;
          border-bottom-left-radius: 50%;
          border-bottom-right-radius: 50%;
          height: 520px;
        }
        @media (max-width: 690px) {
          height: 390px;
        }
      }
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }
  }
}
</style>